export const ROLE_ADMIN = 'Admin'
export const ROLE_ADMIN_HOTEL = 'AdminHotel'
export const ROLE_AFFILIATE = 'Affiliate'
export const ROLE_BOOKING_BUDDY = 'BookingBuddy'
export const ROLE_DESTINATION_MANAGER = 'DestinationManager'
export const ROLE_HOTELIER = 'Hotelier'
export const ROLE_PLANNER = 'Planner'
export const ROLE_SALES_OPS = 'SalesOps'
export const ROLE_SUPPLIER = 'Supplier'
